// gloss
export type PlatformId =
  | 'zealot'
  | 'userevidence'
  | 'salesforce'
  | 'hubspot'
  | 'amplitude'
  | 'snowflake'
  | 'intercom'
  | 'gong'
  | 'gainsight'
  | 'bevy'
  | 'influitive'
  | 'webex'
  | 'sso';

// gloss
export const PLATFORM_LABELS: Record<PlatformId, string> = {
  zealot: 'UserEvidence Advocacy',
  userevidence: 'UserEvidence',
  salesforce: 'Salesforce',
  hubspot: 'HubSpot',
  amplitude: 'Amplitude',
  snowflake: 'Snowflake',
  intercom: 'Intercom',
  gong: 'Gong',
  gainsight: 'Gainsight',
  bevy: 'Bevy',
  influitive: 'Influitive',
  webex: 'Webex',
  sso: 'SSO',
};

// gloss
export const PLATFORM_ALIASES: Record<PlatformId, string[]> = {
  zealot: ['Zealot', 'UserEvidence Advocacy', 'zealot'],
  userevidence: ['UserEvidence', 'userevidence', 'UE'],
  salesforce: ['Salesforce', 'salesforce', 'SFDC'],
  hubspot: ['HubSpot', 'hubspot'],
  amplitude: ['Amplitude', 'amplitude'],
  snowflake: ['Snowflake', 'snowflake'],
  intercom: ['Intercom', 'intercom'],
  gong: ['Gong', 'gong'],
  gainsight: ['Gainsight', 'gainsight'],
  bevy: ['Bevy', 'bevy'],
  influitive: ['Influitive', 'influitive'],
  webex: ['Webex', 'webex', 'Cisco Webex'],
  sso: ['SSO', 'sso'],
};

const PLATFORM_IDS = Object.keys(PLATFORM_LABELS) as PlatformId[];

// gloss
export const getPlatformId = (idOrAlias: string): PlatformId | undefined => {
  if (!idOrAlias) return undefined;
  const normalized = idOrAlias.toLowerCase();
  return PLATFORM_IDS.find(
    (id) =>
      id === normalized ||
      PLATFORM_LABELS[id].toLowerCase() === normalized ||
      PLATFORM_ALIASES[id].some((alias) => alias.toLowerCase() === normalized),
  );
};
